import React from 'react';
const SearchIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <circle cx="7" cy="7" r="4.5" stroke="#757880" />
      <path
        d="M10.1992 10.2002L13.4992 13.4961"
        stroke="#757880"
        strokeLinecap="round"
      />
    </svg>
  );
};
export default SearchIcon;
